<template>
  <div>
    <b-button variant="outline-light" class="bg-none border-primary rounded-pill ml-2 d-flex align-items-center" @click="modalShow = !modalShow">
      <i class="fas fa-filter text-primary mr-2"></i>
      <p class="mb-0 text-primary">Filter</p>
    </b-button>
    <b-modal title="Filter" class="m-0" footer-class="d-none" v-model="modalShow">
      <b-form @submit.prevent="submit" @reset="resetForm">
        <div class="my-3">
          <div>
            <p class="font-weight-bold mb-2">Reference Number</p>
            <input v-model="formData.service_reference" type="text" name="service_reference"  class="form-control">
          </div>
          <div class="mt-4">
            <p class="font-weight-bold mb-2">Date</p>
            <b-form-datepicker 
              v-model="formData.start_date"
              class="mb-2"
              value-as-date
              :date-format-options="{ month: 'numeric', day: 'numeric', year: 'numeric' }"
              today-button
              reset-button
              close-button
              name="start_date"
            ></b-form-datepicker>
            <b-form-datepicker
              v-model="formData.end_date"
              class="mb-2"
              value-as-date
              :date-format-options="{ month: 'numeric', day: 'numeric', year: 'numeric' }"
              today-button
              reset-button
              close-button
              name="end_date"
            ></b-form-datepicker>
          </div>
          <div class="mt-4" v-if="!hidePayers">
            <p class="font-weight-bold mb-2">Payee</p>
            <b-form-select
              id="initial-sort-select"
              :options="payersListing"
              v-model="formData.payer_account"
              value-field="payer_account.id"
              text-field="payer_account.name"
              name="payer_account"
            >
              <template #first>
                <option value="">Select Payee</option>
              </template>
            </b-form-select>
          </div>
          <div class="d-flex align-items-end mt-4">
            <b-button variant="primary" class="w-100 mr-1" type="submit">Filter</b-button>
            <b-button variant="success" class="w-100 ml-1" type="reset">
              <i class="fas fa-sync-alt"></i>
              Reset
            </b-button>
          </div>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import store from '../store';
import TransactionAPI from '../api/transactions_api';

export default {
  props: ['filtersSubmit', 'reset', 'hidePayers'],
  data: () => ({
    modalShow: false,
    formData: {
      service_reference: null,
      start_date: null,
      end_date: null,
      payer_account: null
    },
    dirty: false
  }),
  mounted() {
    TransactionAPI.methods.getPayers();
  },
  methods: {
    submit(event) {
      const { service_reference, start_date, end_date, payer_account } = Object.fromEntries(new FormData(event.target));    
      const params = {
        service_reference: service_reference,
        start_date: start_date,
        end_date: end_date,
        payer_account: payer_account ? payer_account : null,
        //page: 1// 1,2,3,4,5....
        //page_size: 10
      };

      this.filterProperties = {
        ...this.filterProperties,
        ...params
      };

      if (this.dirty) {
        this.dirty = false;
        this.$emit('filtersSubmit', params);
        this.modalShow = false;
      }
    },
    resetForm(event) {
      if (this.dirty) {
        event.target.reset();
        
        for (var prop in this.formData) { 
          this.formData[prop] = null;
        }

        this.$emit('reset');
        this.modalShow = false;
        this.dirty = false;
      }
    }
  },
  computed: {
    payersListing: {
      get: function() {
        return store.state.payersListing;
      },
      set: function(newValue) {
        store.state.payersListing = newValue;
      } 
    },
    filterProperties: {
      get: function() {
        return store.state.filterProperties;
      },
      set: function(newValue) {
        store.state.filterProperties = newValue;
      } 
    }
  },
  watch: {
    formData: {
      handler(newVal, oldVal) {
        this.dirty = true;
      },
      deep: true
    }
  }
}
</script>
